module.exports = __webpack_public_path__ + "e9b8b9a7d8efb863b8440077ce2e006e.svg";